import React from 'react';
import {IARButtonProps} from '@montana/shared/ar-button/ar-button';
import {SvgIcon} from '@montana/shared/svg-icon';
import {useTranslations} from '@montana/containers/translations';
import { isAndroid, isIOS } from '@montana/helpers/device.helper'

export const ARButton: React.FC<IARButtonProps> = React.memo((props: IARButtonProps): JSX.Element => {
    const {url} = props;
    const translate = useTranslations();

    return (
        <div className="ar__container">
            {isIOS && !!url.length &&
                <a rel="ar" href={url} role="link" aria-label={''}>
                    <img src=""/>
                    <div className="ar__content">
                        <span>{translate(t => t.productPage.arLinkText, '[View product live]')}</span><SvgIcon iconName="ar"/>
                    </div>
                </a>
            }
            {isAndroid && !!url.length &&
                <a href={`intent://arvr.google.com/scene-viewer/1.0?file=${url}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`} role="link" aria-label={''}>
                    <div className="ar__content">
                        <span>{translate(t => t.productPage.arLinkText, '[View product live]')}</span><SvgIcon iconName="ar"/>
                    </div>
                </a>
            }
        </div>
    )
})
